import e from"../node_modules/eventemitter3/index.js";import o from"./lib/supportPassiveEvent.js";var s={connections:{},EE:new e,enableResizeInfo:!1,enableScrollInfo:!1,listeners:{},removers:[],supportPassiveEvent:o};export{s as default};
//# sourceMappingURL=globalVars.js.map
